(function () {

	'use strict';

	/*global $:true, cologic:true */

	// "Feature Slider" content element (CType "feature_slider", FeatureSlider.fluid.html): an
	// endless drag slider with dots and arrows like cologic.initStdSlider (same
	// #sliderContainer-N / #sliderButtonContainer-N / #sliderArrowContainer-N contract and fade
	// callbacks), several features side by side (slide widths in _feature-slider.scss), no
	// auto-advance. The slider height comes from the tallest feature via
	// cologic.initCrawlerSliderHeight (cologic-crawlerControls.js) - iosSlider alone would
	// collapse it to 0px.

	let cologicFeatureSlider = {

		initFeatureSlider: function (rootSelector, elemNr) {
			let $root = $(rootSelector);
			let sliderId = '#sliderContainer-' + elemNr;
			if ($root.length <= 0 || $(sliderId).length <= 0) return;

			$(sliderId).iosSlider({
				snapToChildren: true,
				scrollbar: false,
				scrollbarHide: true,
				desktopClickDrag: true,
				autoSlide: false,
				startAtSlide: 1,
				navSlideSelector: $('#sliderButtonContainer-' + elemNr + ' .sliderButton'),
				navPrevSelector: $('#sliderArrowContainer-' + elemNr + ' .prev'),
				navNextSelector: $('#sliderArrowContainer-' + elemNr + ' .next'),
				onSlideChange: cologic.someCallback,
				onSlideStart: cologic.fadeSliderOut,
				onSlideComplete: cologic.fadeSliderIn,
				infiniteSlider: true,
				responsiveSlideContainer: true,
				responsiveSlides: true,
				onSliderResize: cologic.sliderUpdate
			});

			cologic.initCrawlerSliderHeight($root, {slider: '.slider', card: '.feature-slide'});
		}

	};

	//------------------------------------

	//gemeinsam verfügbar machen
	if (typeof (cologic) === 'undefined')
		window.cologic = {};
	$.extend(cologic, cologicFeatureSlider);
}());
